import React, { useState, useCallback } from "react";
import { formStyles as s, downloadBtnStyle, DownloadIcon, requiredInput } from "./formStyles";
import SignaturePad from "../components/SignaturePad";
import { displayDateFormat } from "../utils/format";



const DURING_MEETING_OPTIONS = ["Select One", "said", "advised", "explained"];
const IMPROVE_THEIR_OPTIONS = ["Select One", "issue", "performance", "conduct"];
const HAVE_BEEN_OPTIONS = ["Select One", "taken", "offered"];
const AND_ANY_OPTIONS = ["Select One", "deadlines", "targets", "expectations"];

const RecordMeetingForm = ({ pdfUrl = "/static/pdffilters/Record-Staff-Meeting.pdf" }) => {
  const [form, setForm] = useState({
    // Page 1 — Meeting Info
    dateOfMeeting: "",
    recordWith: "",
    regarding: "",
    briefDescription: "",
    timeNow: "",
    metWith: "",
    alsoWith: "",
    // Page 2 — During the Meeting
    duringMeetingDD: "Select One",
    duringMeetingText: "",
    thatText: "",
    andText1: "",
    andText2: "",
    responseText: "",
    inOrderToAssist: "",
    improveTheirDD: "Select One",
    encloseDetails: "",
    haveBeenDD: "Select One",
    beenText: "",
    andAnyDD: "Select One",
    // Page 3 — Other Details & Signatures
    otherDetails: "",
    dateSigned: "",
    printNameManager: "",
    printNameMember: "",
    printNameWitness: "",
  });

  // Signature data URLs
  

  const [signatures, setSignatures] = useState({
    manager: null,
    member: null,
    witness: null,
  });

  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const u = (field, value) => setForm((p) => ({ ...p, [field]: value }));

  const handleSigSave = useCallback((key) => (dataUrl) => {
    setSignatures((p) => ({ ...p, [key]: dataUrl }));
  }, []);

  const handleSigClear = useCallback((key) => () => {
    setSignatures((p) => ({ ...p, [key]: null }));
  }, []);

  const isValid = form.dateOfMeeting && form.recordWith.trim() && form.timeNow && form.regarding.trim() && form.briefDescription.trim() && form.metWith.trim() && form.printNameManager.trim() && form.printNameMember.trim() && form.printNameWitness.trim() && form.dateSigned;

  const handleDownload = async () => {
    setDownloading(true);
    setError(null);
    try {
      const { PDFDocument, PDFName } = await import("pdf-lib");
      const pdfBytes = await fetch(pdfUrl).then((r) => {
        if (!r.ok) throw new Error("Could not load PDF template");
        return r.arrayBuffer();
      });
      const pdfDoc = await PDFDocument.load(pdfBytes);
      pdfDoc.setTitle(`Record Of Meeting - ${form.recordWith}`);
      const f = pdfDoc.getForm();

      const setText = (name, val) => {
        try {
          const field = f.getTextField(name);
          field.setFontSize(12);
          field.setText(val || "");
        } catch (_) {}
      };

      const setDrop = (name, val) => {
        try { f.getDropdown(name).select(val || ""); } catch (_) {}
      };

      // ── Page 1: Meeting Info ──
      setText("Dateofmeeting", displayDateFormat(form.dateOfMeeting));
      setText("Textrecordwith", form.recordWith);
      setText("Textregarding", form.regarding);
      setText("Briefdescription", form.briefDescription);
      setText("Timenow", form.timeNow);
      setText("Textmetwith", form.metWith);
      setText("Textalsowith", form.alsoWith);

      // ── Page 2: During the Meeting ──
      setDrop("Dropdownduring-meeting", form.duringMeetingDD);
      setText("Textduringthemeeting", form.duringMeetingText);
      setText("Textthat", form.thatText);
      setText("Textand1", form.andText1);
      setText("Textand2", form.andText2);
      setText("saidinresponsethat", form.responseText);
      setText("Textinordertoassist", form.inOrderToAssist);
      setDrop("Dropdown-improve-their", form.improveTheirDD);
      setText("Textenclosedetails", form.encloseDetails);
      setDrop("Dropdown-have-been", form.haveBeenDD);
      setText("Textbeen2", form.beenText);
      setDrop("Dropdown-and-any", form.andAnyDD);

      // ── Page 3: Other Details & Names ──
      setText("Textrecordanyotherdetails", form.otherDetails);
      setText("PrintNameManager", form.printNameManager);
      setText("PrintNameMember", form.printNameMember);
      setText("PrintNameWitness", form.printNameWitness);
      setText("DateSign", displayDateFormat(form.dateSigned));

      // ── Signature embedding ──
      const embedSigOnPage = async (sigDataUrl, fieldName) => {
      if (!sigDataUrl) return;
      try {
        const base64 = sigDataUrl.split(",")[1];
        const sigBytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
        const sigImage = await pdfDoc.embedPng(sigBytes);

        const sigField = f.getTextField(fieldName);
        const widgets = sigField.acroField.getWidgets();
        if (widgets.length === 0) return;

        const widget = widgets[0];
        const rect = widget.getRectangle();

        const pages = pdfDoc.getPages();
        let targetPage = null;

        for (const page of pages) {
          const annotsRef = page.node.get(PDFName.of("Annots"));
          if (!annotsRef) continue;
          const annots = page.node.context.lookup(annotsRef);
          if (!annots) continue;
          const arr = annots.asArray ? annots.asArray() : [];
          for (const ref of arr) {
            if (ref === widget.ref) { targetPage = page; break; }
          }
          if (targetPage) break;
        }

        if (!targetPage) {
          for (const page of pages) {
            const annotsRef = page.node.get(PDFName.of("Annots"));
            if (!annotsRef) continue;
            const annots = page.node.context.lookup(annotsRef);
            if (!annots) continue;
            const arr = annots.asArray ? annots.asArray() : [];
            for (const ref of arr) {
              const resolved = page.node.context.lookup(ref);
              if (resolved === widget.dict) { targetPage = page; break; }
            }
            if (targetPage) break;
          }
        }

        if (!targetPage) targetPage = pages[pages.length - 1];

        f.removeField(sigField);

        const aspectRatio = sigImage.width / sigImage.height;
        let drawWidth = rect.width;
        let drawHeight = drawWidth / aspectRatio;
        if (drawHeight > rect.height) {
          drawHeight = rect.height;
          drawWidth = drawHeight * aspectRatio;
        }

        const x = rect.x + (rect.width - drawWidth) / 2;
        const y = rect.y + (rect.height - drawHeight) / 2;

        targetPage.drawImage(sigImage, { x, y, width: drawWidth, height: drawHeight });
      } catch (e) {
        console.error(`Sig embed failed for ${fieldName}:`, e);
        try { f.getTextField(fieldName).setText("[Signed]"); } catch (_) {}
      }
    };

      await embedSigOnPage(signatures.manager, "SignManager");
      await embedSigOnPage(signatures.member, "SignMember");
      await embedSigOnPage(signatures.witness, "SignWitness");
      

      // ── Flatten and save ──
      f.flatten();
      const filled = await pdfDoc.save();
      const blob = new Blob([filled], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Record-Meeting-${form.recordWith || "Form"}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("PDF fill error:", err);
      setError(err.message || "Failed to generate PDF");
    } finally {
      setDownloading(false);
    }
  };

  const handleReset = () => {
    setForm({
      dateOfMeeting: "", recordWith: "", regarding: "", briefDescription: "",
      timeNow: "", metWith: "", alsoWith: "",
      duringMeetingDD: "Select One", duringMeetingText: "", thatText: "",
      andText1: "", andText2: "", responseText: "",
      inOrderToAssist: "", improveTheirDD: "Select One",
      encloseDetails: "", haveBeenDD: "Select One", beenText: "",
      andAnyDD: "Select One",
      otherDetails: "", dateSigned: "",
      printNameManager: "", printNameMember: "", printNameWitness: "",
    });
    setSignatures({ manager: null, member: null, witness: null });
    setError(null);
  };

  return (
    <div style={s.wrapper}>
      <style>{s.spinKeyframes}</style>
      <h2 style={s.title}>Record Of Meeting With Employee</h2>
      <p style={s.subtitle}>Complete the meeting record and download the filled PDF</p>

      {/* ── Page 1: Meeting Info ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 1 — Meeting Information</p>
        <div style={s.sectionLabel}>Meeting Details</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Date of Meeting *</label>
            <input style={requiredInput(form.dateOfMeeting)} type="date" value={form.dateOfMeeting} onChange={(e) => u("dateOfMeeting", e.target.value)} />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Time Now</label>
            <input style={requiredInput(form.timeNow)} type="time" value={form.timeNow} onChange={(e) => u("timeNow", e.target.value)} />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Record of Meeting With *</label>
            <input style={requiredInput(form.recordWith)} value={form.recordWith} onChange={(e) => u("recordWith", e.target.value)} placeholder="Employee name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Regarding</label>
            <input style={requiredInput(form.regarding)} value={form.regarding} onChange={(e) => u("regarding", e.target.value)} placeholder="Subject of meeting" />
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Brief Description</label>
          <textarea style={requiredInput(form.briefDescription)} value={form.briefDescription} onChange={(e) => u("briefDescription", e.target.value)} placeholder="Brief description of the meeting..." />
        </div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>I Met With *</label>
            <input style={requiredInput(form.metWith)} value={form.metWith} onChange={(e) => u("metWith", e.target.value)} placeholder="Person met with" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Also Present Was</label>
            <input style={s.input} value={form.alsoWith} onChange={(e) => u("alsoWith", e.target.value)} placeholder="Other attendees" />
          </div>
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Page 2: During the Meeting ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 2 — During the Meeting</p>
        <div style={s.sectionLabel}>Meeting Discussion</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>During the Meeting I...</label>
            <select
              style={s.input}
              value={form.duringMeetingDD}
              onChange={(e) => u("duringMeetingDD", e.target.value)}
            >
              {DURING_MEETING_OPTIONS.map((opt) => (
                <option key={opt} value={opt} style={s.optionStyle}>{opt}</option>
              ))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>That...</label>
            <input style={s.input} value={form.thatText} onChange={(e) => u("thatText", e.target.value)} placeholder="What was communicated" />
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>During the Meeting Details</label>
          <textarea style={s.textareaLarge} value={form.duringMeetingText} onChange={(e) => u("duringMeetingText", e.target.value)} placeholder="Details of what was discussed during the meeting..." />
        </div>

        <div style={{ ...s.sectionLabel, marginTop: 20 }}>Response</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>And (employee name)</label>
            <input style={s.input} value={form.andText1} onChange={(e) => u("andText1", e.target.value)} placeholder="Employee name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Said in Response That</label>
            <input style={s.input} value={form.responseText} onChange={(e) => u("responseText", e.target.value)} placeholder="Employee response" />
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Response Details</label>
          <textarea style={s.textarea} value={form.andText2} onChange={(e) => u("andText2", e.target.value)} placeholder="Further details of the response..." />
        </div>

        <div style={{ ...s.sectionLabel, marginTop: 20 }}>Improvement Actions</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>In Order to Assist</label>
            <input style={s.input} value={form.inOrderToAssist} onChange={(e) => u("inOrderToAssist", e.target.value)} placeholder="Employee name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>To Improve Their</label>
            <select
              style={s.input}
              value={form.improveTheirDD}
              onChange={(e) => u("improveTheirDD", e.target.value)}
            >
              {IMPROVE_THEIR_OPTIONS.map((opt) => (
                <option key={opt} value={opt} style={s.optionStyle}>{opt}</option>
              ))}
            </select>
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>I Enclose Details of What Steps That Have</label>
          <textarea style={s.textarea} value={form.encloseDetails} onChange={(e) => u("encloseDetails", e.target.value)} placeholder="Steps taken or to be taken..." />
        </div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Been</label>
            <select
              style={s.input}
              value={form.haveBeenDD}
              onChange={(e) => u("haveBeenDD", e.target.value)}
            >
              {HAVE_BEEN_OPTIONS.map((opt) => (
                <option key={opt} value={opt} style={s.optionStyle}>{opt}</option>
              ))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>And Any</label>
            <select
              style={s.input}
              value={form.andAnyDD}
              onChange={(e) => u("andAnyDD", e.target.value)}
            >
              {AND_ANY_OPTIONS.map((opt) => (
                <option key={opt} value={opt} style={s.optionStyle}>{opt}</option>
              ))}
            </select>
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Additional Details</label>
          <textarea style={s.textarea} value={form.beenText} onChange={(e) => u("beenText", e.target.value)} placeholder="Additional details..." />
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Page 3: Other Details & Signatures ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 3 — Other Details & Signatures</p>
        <div style={s.sectionLabel}>Other Details</div>
        <div style={s.fieldFull}>
          <label style={s.label}>Record Any Other Details of the Meeting</label>
          <textarea style={s.textareaLarge} value={form.otherDetails} onChange={(e) => u("otherDetails", e.target.value)} placeholder="I also would like to state that..." />
        </div>

        <div style={{ ...s.sectionLabel, marginTop: 20 }}>Signatures</div>
        <div style={s.signatureGrid}>
          <div style={s.signatureBlock}>
            <span style={{
              ...s.signatureLabel,
              color: signatures.manager ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
            }}>
              Manager Signature
            </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("manager")} onClear={handleSigClear("manager")} />
          </div>
          <div style={s.signatureBlock}>
            <span style={{
              ...s.signatureLabel,
              color: signatures.member ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
            }}>
              Member Signature
            </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("member")} onClear={handleSigClear("member")} />
          </div>
          
        </div>
        <div style={s.signatureGrid}>
          <div style={s.signatureBlock}>
            <span style={{
              ...s.signatureLabel,
              color: signatures.witness ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
            }}>
              Witness Signature
            </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("witness")} onClear={handleSigClear("witness")} />
          </div>
        </div>
        <div style={{ ...s.sectionLabel, marginTop: 20 }}>Names & Date</div>
        <div style={s.fieldGrid3}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Manager Name</label>
            <input style={requiredInput(form.printNameManager)} value={form.printNameManager} onChange={(e) => u("printNameManager", e.target.value)} placeholder="Manager name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Member Name</label>
            <input style={requiredInput(form.printNameMember)} value={form.printNameMember} onChange={(e) => u("printNameMember", e.target.value)} placeholder="Member name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Witness Name</label>
            <input style={requiredInput(form.printNameWitness)} value={form.printNameWitness} onChange={(e) => u("printNameWitness", e.target.value)} placeholder="Witness name" />
          </div>
        </div>
        <div style={{ marginTop: 14 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Date Signed</label>
            <input style={requiredInput(form.dateSigned)} type="date" value={form.dateSigned} onChange={(e) => u("dateSigned", e.target.value)} />
          </div>
        </div>
      </div>

      <div style={s.btnRow}>
        <button style={downloadBtnStyle(isValid)} onClick={handleDownload} disabled={!isValid || downloading}>
          {downloading ? (<><span style={s.spinner} /> Generating PDF...</>) : (<><DownloadIcon /> Download Filled PDF</>)}
        </button>
        <button style={s.resetBtn} onClick={handleReset}>Reset</button>
      </div>
      {error && <div style={s.error}>{error}</div>}
    </div>
  );
};

export default RecordMeetingForm;